/** Prompts shown first with a star (until user starring is persisted). */
export const FEATURED_VISUAL_PROMPT_IDS: readonly string[] = [
  'rewrite-message',
  'announce-system-change',
  'meeting-notes',
  'service-desk-ticket',
] as const;

export const isFeaturedVisualPrompt = (promptId: string): boolean =>
  FEATURED_VISUAL_PROMPT_IDS.includes(promptId);
